"use client";

import { createContext, useContext } from "react";

interface PriceContextValue {
	priceType: "minimum" | "specific";
	price: number;
	isCheckModeCompletePanel: boolean;
}

export const PriceContext = createContext<PriceContextValue>({} as PriceContextValue);

export function usePriceContext() {
	const context = useContext(PriceContext);

	if (context === null) throw new Error("PriceContext is not available");

	return context;
}
